if (__FIREBASE_PROD_ENV__ && !__DEV__) {
	module.exports = require('./Environment.prod');
} else {
	module.exports = require('./Environment.dev');
}